export enum QueryKeys {
  ListPassengers = 'listPassengers',
  PassengerDetails = 'passengerDetails',
  UserDetails = 'userDetails',
  ListUsers = 'listUsers',
  TripDetails = 'tripDetails',
  ListTrips = 'listTrips',
  CalendarTrips = 'calendarTrips',
  Trip = 'trip',
  TrackingId = 'trackingId',
  Person = 'person',
  DriverMessage = 'driverMessage',
  IsUserEmailAddressAvailable = 'isUserEmailAddressAvailable',
  Attributes = 'attributes',
  AddressTypes = 'addressTypes',
  AddressInstitutions = 'addressInstitutions',
  ContactTypes = 'contactTypes',
  Agreements = 'agreements',
  UserRoles = 'userRoles',
  Roles = 'roles',
  AuthenticationTypes = 'authenticationTypes',
  UserNameAvailable = 'userNameAvailable',
  PassengerAddress = 'passengerAddress',
  PassengerAssignedUsers = 'passengerAssignedUsers',
  PassengerSchedules = 'passengerSchedules',
  AgreementPartners = 'agreementPartners',
  OperationalAttributes = 'operationalAttributes',
  PassengerNeeds = 'passengerNeeds',
  ListAbsences = 'listAbsences',
  NotificationSummary = 'notificationSummary',
  ListNotifications = 'listNotifications',
  ScheduleTypes = 'scheduleTypes',
  SearchAbsences = 'searchAbsences',
  SchedulePendingReview = 'schedulePendingReview',
  Locations = 'locations',
  PassengerPendingReview = 'passengerPendingReview',
  TravelAddresses = 'travelAddresses',
}

export type PassengerStatusFilter = 'COMPLETED' | 'INACTIVE' | 'ACTIVE' | 'AWAITING_APPROVAL';

export interface PassengerListParams {
  searchString: string;
  pageNumber: number;
  itemsPerPage: number;
  statusFilter?: PassengerStatusFilter;
  agreements?: Array<{ id: number; name?: string }>;
  institutionIds?: Array<string | null | undefined>;
}

export interface PassengerListQueryOptions {
  enabled?: boolean;
}

export interface QueryThrowOnErrorOptions {
  throwOnError?: boolean | ((error: unknown) => boolean);
}

export interface OperationalAttributesQueryOptions extends QueryThrowOnErrorOptions {
  enabled?: boolean;
}
